class FileUploadChangeDirective {
  constructor() {
    this.scope = {
      fileUploadChange: '&',
    };
    this.link = (scope, element, attrs) => {
      element.on('change', (event) => {
        scope.fileUploadChange({ $event: event });
        event.target.value = '';
      });
      scope.$on('$destroy', () => {
        element.off();
      });
    };
  }
}

export default FileUploadChangeDirective;



// WEBPACK FOOTER //
// ./src/modules/utils/file-upload/components/file-upload-change-directive.js